module.exports = __webpack_public_path__ + "static/TakeshiAndHiroshi4-b31f2c4114ddc56b65cc5ef9127c924c.png";